<template>
    <el-button type="primary"  icon="el-icon-setting" v-on:click="clickEvent()">{{btnCon}}</el-button>
</template>
  
  <script>
  
  export default {
    name: 'form-setting-button',
    props: {
      btnCon: {
            type: String,
            default: () => {
                return "设置"
            }
        },
    },
    data () {
      return {
      }
    },
    mounted () {
    },
    methods: {
        clickEvent(){
            this.$emit('select-type',1);
        }
    }
  }
  </script>
  
  <style lang="scss">
  </style>
  


// WEBPACK FOOTER //
// FormSettingButton.vue?79f4678e